import { render, staticRenderFns } from "./UsersModal.vue?vue&type=template&id=dfaa70ea&"
import script from "./UsersModal.vue?vue&type=script&lang=js&"
export * from "./UsersModal.vue?vue&type=script&lang=js&"
import style0 from "./UsersModal.vue?vue&type=style&index=0&id=dfaa70ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports